import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import classNames from 'classnames';
import { Container } from '../../../../../symphony';
import {
	ActionType,
	RequestType,
} from '../../../global-interface';
import { HeaderLeftSide } from '../LeftSide/LeftSide';
import { HeaderRightSide } from '../RightSide/RightSide';
import { lePlaygroundContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';
import { SlActions } from '../../../services/ActionsService/sl-actions';

import s from './Header.scss';
import { IUserCode } from '../../../../../api/public/code-api';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';

export interface IHeaderProps { }

export const Header: React.FC<IHeaderProps> = React.memo(() => {
	useStyles(s);

	const { isDarkMode$: isDarkMode, codeData$: codeData } = useContainerData(lePlaygroundContext.value, SlDataService, ['codeData$', 'isDarkMode$']);

	const { actions$ } = Container.take(lePlaygroundContext.value, SlActions);

	const onChangeEditorMode = (state: boolean): void => {
		actions$.next({
			type: ActionType.OnHeaderChangeModeToggle,
			requestType: RequestType.Parallel,
			data: {
				state,
			},
		});
	};

	return (
		<div
			className={classNames('sl-playground-header-wrapper', {
				dark: isDarkMode,
			})}
		>
			<div className="sl-playground-header-wrapper__content">
				<HeaderLeftSide
					isDarkMode={isDarkMode}
				/>
				<HeaderRightSide
					language={(codeData as IUserCode)?.language}
					onChangeEditorMode={onChangeEditorMode}
					isDarkMode={isDarkMode}
				/>
			</div>
		</div>
	);
});
